// Action types
export const SET_LOADING = "SET_LOADING";
export const SET_PROPERTIES = "SET_PROPERTIES";
